"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function MomentumMethodologyCopy() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section id="splitcontentwithimage" className="bg-background text-white py-24 overflow-hidden !h-[775px] lg:py-[120px]">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div ref={ref} className={`grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="lg:col-span-6 flex flex-col gap-8">
            <div className="space-y-6">
              <h2 className="font-default tracking-tight leading-tight !font-bold !text-[hsl(0,0%,100%)] !text-4xl ![margin:-150px_0px_24px_30px]">Beating Goals to Launch Rewarding Part of Career</h2>

              <div className="space-y-4">
                <p className="text-base text-white leading-relaxed ![margin:0px_0px_16px_20px] md:text-lg">"Working with Raamon &amp; Paolo is time well spent.&nbsp;</p>
                <p className="text-base text-white leading-relaxed ![margin:0px_0px_16px_20px] md:text-lg">They helped my thinking process and patterns on how to attack certain things in the right way.&nbsp;</p>
                <p className="text-base text-white leading-relaxed ![margin:0px_0px_16px_20px] md:text-lg">It was a strengthening mental exercise that’s given me better control over emotions and thinking patterns to know what is more effective.&nbsp;</p>
                <p className="text-base text-white leading-relaxed ![margin:0px_0px_16px_20px] md:text-lg">Knowing how to find peace and quiet has helped me not get overwhelmed. Their guidance has been valuable in helping be more centered as I continue on the journey.&nbsp;</p>
                <p className="text-base text-white leading-relaxed ![margin:0px_0px_16px_20px] md:text-lg">Their approach was different from the usual process based training I’ve had in the past."</p>
                <p className="text-base text-white leading-relaxed ![margin:0px_0px_0px_20px] md:text-lg"><b>Rick Smith</b><div><b>VP of Business Development, Vicinity Energy</b></div></p>
                
                
                
              </div>
            </div>

            <div>
              <Button asChild size="lg" className="rounded-full px-8 bg-accent hover:bg-accent-hover text-accent-dark transition-all duration-300">
                
              </Button>
            </div>
          </div>

          {}
          <div className="lg:col-span-6">
            <div className="bg-muted-dark-background rounded-2xl overflow-hidden shadow-strong border border-border/30 w-3/4 mx-auto">
              <img src="https://newmavericks.com/wp-content/uploads/2026/04/Rick.png" alt="NewMavericks Strategic Visual" className="block w-full object-cover hover:scale-105 transition-transform duration-700 ease-in-out" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}